import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const notificationMarkAsReadMutationAtom = createMutationAtomFactory(
  'notifications.markAsRead',
  (params: { ids: string[] }) => ({
    notificationMarkAsRead: {
      __args: {
        ids: params.ids,
      },
    },
  }),
);
